/* LittleG Tool 03 — paint quantity, tins and user-entered material cost.
 * Four-wall rectangular geometry only; not a professional bill of quantities.
 */
(function(global){
  'use strict';
  const positive=(raw,max=10000)=>{
    if(raw===''||raw===null||raw===undefined)return null;
    const n=Number(raw);
    return Number.isFinite(n)&&n>0&&n<=max?n:null;
  };
  const range=(raw,min,max)=>{
    if(raw===''||raw===null||raw===undefined)return null;
    const n=Number(raw);
    return Number.isFinite(n)&&n>=min&&n<=max?n:null;
  };
  const display=n=>Math.round((n+Number.EPSILON)*100)/100;
  function assessPaint(v){
    if(!v||typeof v!=='object'||Array.isArray(v))return null;
    const length=positive(v.length),width=positive(v.width),height=positive(v.height);
    const coverage=positive(v.coverage),coats=range(v.coats,1,5);
    const waste=range(v.waste,0,30);
    if([length,width,height,coverage,coats,waste].includes(null)||!Number.isInteger(coats))return null;
    const grossWall=2*(length+width)*height;
    if(!Number.isFinite(grossWall)||grossWall>1e8)return null;
    const openings=(v.openings===''||v.openings===undefined||v.openings===null)?0:range(v.openings,0,1e8);
    if(openings===null||openings>=grossWall)return null;
    const netWall=grossWall-openings;
    const rawLitres=netWall*coats*(1+waste/100)/coverage;
    if(!Number.isFinite(rawLitres)||rawLitres>1e6)return null;
    // Round the purchase-planning minimum UP to 0.1 L, never down.
    const litres=Math.ceil(rawLitres*10)/10;
    const hasTin=v.tinSize!==''&&v.tinSize!==undefined&&v.tinSize!==null;
    const hasPrice=v.tinPrice!==''&&v.tinPrice!==undefined&&v.tinPrice!==null;
    if(hasPrice&&!hasTin)return null;
    const tinSize=hasTin?positive(v.tinSize):null;
    const tinPrice=hasPrice?range(v.tinPrice,0,100000):null;
    if((hasTin&&tinSize===null)||(hasPrice&&tinPrice===null))return null;
    const tins=tinSize===null?null:Math.ceil(rawLitres/tinSize);
    if(tins!==null&&(!Number.isSafeInteger(tins)||tins>1e6))return null;
    const cost=tins!==null&&tinPrice!==null?tins*tinPrice:null;
    if(cost!==null&&!Number.isFinite(cost))return null;
    return{
      contract:'littleg_paint_estimate_v1',
      gross_wall_area_m2:display(grossWall),
      openings_area_m2:display(openings),
      painted_wall_area_m2:display(netWall),
      coats,
      waste_percent:waste,
      coverage_m2_per_litre_per_coat:coverage,
      estimated_litres:litres,
      tins,
      material_cost_hkd:cost===null?null:display(cost),
      price_basis:cost===null?'not_provided':'user_supplied_hkd_per_tin',
      formal_quantity_survey:false
    };
  }
  if(typeof module!=='undefined'&&module.exports)module.exports={assessPaint};
  if(!global.document)return;
  const fmt=n=>new Intl.NumberFormat(undefined,{maximumFractionDigits:2}).format(n);
  global.document.querySelectorAll('[data-littleg-paint-tool]').forEach(form=>{
    const headline=form.querySelector('[data-paint-headline]');
    const result=form.querySelector('[data-paint-result]');
    const tins=form.querySelector('[data-paint-tins]');
    const container=form.querySelector('[data-paint-result-container]');
    if(!headline||!result||!tins||!container)return;
    const zh=form.dataset.paintLocale!=='en';
    const fields=[...form.querySelectorAll('[data-paint-field]')];
    function render(){
      const values=Object.fromEntries(fields.map(f=>[f.dataset.paintField,f.value.trim()]));
      const missing=['length','width','height','coverage'].filter(k=>values[k]==='');
      tins.hidden=true;tins.textContent='';
      if(missing.length){
        container.dataset.state='idle';
        headline.textContent=zh?'輸入牆面及油漆覆蓋率':'Enter wall dimensions and paint coverage';
        result.textContent=zh?'尚欠 '+missing.length+' 項必需資料。':missing.length+' required input(s) missing.';
        return;
      }
      const estimate=assessPaint(values);
      if(!estimate){
        container.dataset.state='invalid';
        headline.textContent=zh?'請核對油漆計算資料':'Review your paint inputs';
        result.textContent=zh?'請確認尺寸、覆蓋率、扣除面積、塗刷層數及罐裝規格都有效。':'Check dimensions, coverage, opening area, coat count and optional tin information.';
        return;
      }
      container.dataset.state='ready';
      headline.textContent=(zh?'估計需要 ':'Estimated paint: ')+fmt(estimate.estimated_litres)+(zh?' 公升':' L');
      result.textContent=(zh?'牆面約 ':'Gross walls ')+fmt(estimate.gross_wall_area_m2)+' m²'+
        (zh?'；扣除門窗後 ':'; after openings ')+fmt(estimate.painted_wall_area_m2)+' m²'+
        (zh?'；共 '+estimate.coats+' 層，已計 '+fmt(estimate.waste_percent)+'% 損耗。':
          '; '+estimate.coats+' coat(s), including '+fmt(estimate.waste_percent)+'% allowance.');
      if(estimate.tins!==null){
        tins.hidden=false;
        tins.textContent=(zh?'估計要買 '+fmt(estimate.tins)+' 罐。':'Estimated whole tins: '+fmt(estimate.tins)+'.')+
          (estimate.material_cost_hkd!==null
            ? (zh?'按你填寫的單價，材料費約 HK$':' From your price per tin, material cost about HK$')+fmt(estimate.material_cost_hkd)+'。'
            :'');
      }
    }
    form.addEventListener('input',render);
    form.addEventListener('change',render);
    form.addEventListener('submit',event=>{event.preventDefault();render();});
    render();
  });
})(typeof window==='undefined'?globalThis:window);
